module.exports = require('./src/normalizeWheel.js');



//////////////////
// WEBPACK FOOTER
// ./~/normalize-wheel/index.js
// module id = 1219
// module chunks = 64